import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ReactPaginate from "react-paginate";
import SpotifyAPI from "../js/spotifyapi";

let items = [];
let loadingTracks = true;
let listFilter = "";
let selectedArtistId = "";

function ModalCrearLista({ selectedID }) {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCrearLista = async () => {
    setLoading(true);
    await SpotifyAPI.createSpotifyPlayList(selectedArtistId, name, description);
    setLoading(false);
    setShow(false);
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    setShow(false);
  };

  const handleShow = () => {
    setName("");
    setDescription("");
    setShow(true);
  };

  const handleListName = (e) => {
    setName(e.target.value);
  };

  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  return (
    <>
      <Button
        variant="info"
        className={`text-nowrap ${selectedID === "" ? "disabled" : ""}`}
        onClick={handleShow}
      >
        Crear lista
      </Button>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Nueva lista de reproduccion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Nombre de la lista:</Form.Label>
              <Form.Control type="text" onChange={handleListName} autoFocus />
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Descripcion:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  onChange={handleDescription}
                />
              </Form.Group>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button
            variant="primary"
            className={`${
              loading === false && name !== "" && description !== ""
                ? ""
                : "disabled"
            }`}
            onClick={handleCrearLista}
          >
            {loading && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            <span>{`${
              loading === true ? " Creando lista..." : " Crear lista"
            }`}</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function Spinner() {
  return (
    <>
      <div className="d-flex align-items-center text-success mt-2">
        <strong className="text-dark">Cargando canciones...</strong>
        <div
          className="spinner-border ms-auto"
          role="status"
          aria-hidden="true"
        ></div>
      </div>
    </>
  );
}

function Items({ currentItems, onItemClick, onChangeFilter }) {
  const [selectedID, setSelectedID] = useState("");
  return (
    <>
      <form className="d-flex mt-2" role="search">
        <input
          className="form-control me-2"
          type="search"
          placeholder="Elegi una cacion que te encante &hearts;"
          aria-label="Elegi una cacion que te encante &hearts;"
          onChange={(e) => onChangeFilter(e)}
        />
        {<ModalCrearLista selectedID={selectedID} />}
      </form>
      {currentItems && (
        <ol className="list-group mt-2 mb-2">
          {currentItems.map((tracks) => (
            <li
              key={tracks.track.id}
              className={`list-group-item list-group-item-action d-flex justify-content-between align-items-start ${
                selectedID === tracks.track.id ? "active" : ""
              }`}
              onClick={() => {
                setSelectedID(tracks.track.id);
                selectedArtistId = tracks.track.artists[0].id;
              }}
            >
              <div className="mt-2 mr-3">
                <button
                  type="button"
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    onItemClick(tracks);
                  }}
                >
                  Reproducir
                </button>
              </div>
              <div className="ms-2 me-auto">
                <div className="fw-bold">{tracks.track.name}</div>
                {tracks.track.album.artists
                  .map((artist) => artist.name)
                  .join(", ")}
              </div>
              <img
                src={tracks.track.album.images[2].url}
                width="50"
                height="50"
                className="d-inline-block align-center"
              />
            </li>
          ))}
        </ol>
      )}
    </>
  );
}

function PaginatedTracks({ itemsPerPage, onPlayTrack }) {
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    async function fetchData() {
      if (items.length === 0) {
        items = await SpotifyAPI.getSpotifyTracks();
        loadingTracks = false;
      }
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(filterTracks(items).slice(itemOffset, endOffset));
      setPageCount(Math.ceil(filterTracks(items).length / itemsPerPage));
    }
    fetchData();
  }, [itemOffset, itemsPerPage]);

  const handlePageClick = (event) => {
    const filteredItems = filterTracks(items);
    const newOffset = (event.selected * itemsPerPage) % filteredItems.length;
    setItemOffset(newOffset);
  };

  const handleFilter = (event) => {
    listFilter = event.target.value.toLowerCase();
    const endOffset = itemOffset + itemsPerPage;
    const filteredItems = filterTracks(items);
    setCurrentItems(filteredItems.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(filteredItems.length / itemsPerPage));
  };

  const filterTracks = (array) => {
    return array.filter((tracks) =>
      JSON.stringify(tracks.track).toLowerCase().includes(listFilter)
    );
  };

  const handleItemClick = (event) => {
    let array = filterTracks(items);
    let index = array.indexOf(event);
    if (array.length > 100) {
      array = array.slice(index, index + 100);
      index = 0;
    }
    const uris = array.map((x) => x.track.uri);
    onPlayTrack(uris, index);
  };

  return (
    <>
      <Items
        currentItems={currentItems}
        onItemClick={handleItemClick}
        onChangeFilter={handleFilter}
      />
      {loadingTracks && <Spinner />}
      {!loadingTracks && (
        <ReactPaginate
          previousLabel="Anterior"
          nextLabel="Siguiente"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          activeClassName="active"
        />
      )}
    </>
  );
}

export default PaginatedTracks;
